<template>
  <view class="home-main">
    <view wx:style="margin-bottom: 20px; padding: 24px; background: #ffffff;">
      <view wx:style="margin: 10px 0; border: 3px solid #cccccc"></view>
      <button bindtap="travelSystem">差旅制度</button>
    </view>
    <view wx:style="text-align: center;">
      <view wx:style="margin: 10px 0;"></view>
    </view>
    <view wx:style="margin: 10px 0;"></view>
    <view wx:style="margin: 10px 0;"></view>
    <warm-tips title="温馨提示" content="{{content}}"></warm-tips>
    <view wx:style="margin: 10px 0;"></view>

    <refund-reason-card title="请选择退票原因" content="{{reasonContent}}"/>
    <view wx:style="margin: 10px 0;"></view>
  </view>
  <travel-system-drawer
    show="{{ travelSystemVisible }}"
    trainInfoContent="{{ trainInfoContent }}"
    bind:close="travelSystem"
  />
</template>

<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import { parseDate, calcDateNum, formatDate, getDayByOffset } from '@didi/es-mpx-shared'
  import store from '@/store'
  import initMixin from '@/mixins'

  createPage({
    mixins: [initMixin],
    data: {
      selectType: '',
      content: [
        '一张有效身份证件同一乘车日期同一车次只能购买一张车票高铁动卧列车除外购票时可使用的有效身份证件包括：中华人民共和国居民身份证、港澳居民来往内地通行证、台湾居民来往大陆通行证可行',
      ],
      reasonContent: [
        { name: '行程变更' },
        { name: '出行时间选择错误' },
        { name: '坐席选择错误' },
        { name: '其他' },
      ],
      list: [
        { name: '下单成功', value: '2020-02-02  17:14:02', isSuccess: 1 },
        { name: '下单失败', value: '2020-02-02  17:14:02', isSuccess: 0 },
        { name: '下单成功', value: '2020-02-02  17:14:02', isSuccess: 1 },
        { name: '下单成功', value: '2020-02-02  17:14:02', isSuccess: 1 },
      ],
      ticketData: [
        {
          seat_type_name: '二等座',
          seat_type: 'O',
          ticket_num: '有',
          ticket_price: 3350,
          is_support_choose_seats: 1,
          is_can_HB: 0,
          discount: 0,
          is_over_standard: 1,
        },
        {
          seat_type_name: '一等座',
          seat_type: 'M',
          ticket_num: '有',
          ticket_price: 5650,
          is_support_choose_seats: 1,
          is_can_HB: 0,
          discount: 0,
          is_over_standard: 0,
        },
        {
          seat_type_name: '一等座',
          seat_type: 'M222',
          ticket_num: '有',
          ticket_price: 5650,
          is_support_choose_seats: 1,
          is_can_HB: 0,
          discount: 0,
          is_over_standard: 0,
        },
        {
          seat_type_name: '二等卧',
          seat_type: 'J',
          ticket_num: '有',
          ticket_price: 0,
          is_support_choose_seats: 0,
          is_can_HB: 0,
          discount: 0,
          is_over_standard: 0,
        },
        {
          seat_type_name: '一等卧',
          seat_type: 'I',
          ticket_num: '有',
          ticket_price: 0,
          is_support_choose_seats: 0,
          is_can_HB: 0,
          discount: 0,
          is_over_standard: 0,
        },
        {
          seat_type_name: '软座',
          seat_type: '2',
          ticket_num: '13',
          ticket_price: 3350,
          is_support_choose_seats: 0,
          is_can_HB: 0,
          discount: 0,
          is_over_standard: 1,
        },
      ],
      selectSeatInfo: {
        // "seat_type_name": "一等座",
        // "seat_type": "M",
        // "ticket_num": "有",
        // "ticket_price": 5650,
        // "is_support_choose_seats": 1,
        // "is_can_HB": 0,
        // "discount": 0,
        // 'is_over_standard': 0
      },
      trainInfo: {
        train_no: '24000G130000',
        train_code: 'G1300',
        from_station_telecode: 'VNP',
        to_station_telecode: 'TIP',
        from_station_name: '北京南',
        to_station_name: '天津南',
        start_station_name: '北京南',
        end_station_name: '上海虹桥',
        start_time: '2021-02-16 07:00:00',
        arrive_time: '2021-02-16 07:30:00',
        travel_time: 30,
        travel_time_name: '历时0小时30分钟',
        sale_flag: 0,
        sale_flag_msg: '预订',
        is_support_card: 1,
        train_secrets:
          'D3%AU0JhR8uzsjGLUjxqC2SQ6ch3RIP0NWtMk8MuP9zJqeA0%nmQjspMBbF2%tYTHuxdBycNr0GXPcmZye9HnaFFh9WulcEF2%Ity3FF3ngOqRKvD4fOtI4RmvEBww7teA0%B2%5IB2%7jay6kbdQkd1lVkjnz7o4oAfB2%b1vfnod0ZlnQWD1WrHTgd7TaB2%V1YB2%DnI0ZWBpIxnleF2%DnXSA0%gXBHdSD1xRsilmlpjLPBB9c8L8shoj4JOb9ybe2UHhpHNiUdLW8bB2%QSJ1UT31CmlwtGDKF2%zXK1SnA0%EHSsqF2%YCkKM4mPj0BbHQn0mzGxHqcfmD5k0RHlMF2%uDoIwVIuzMwe1XFLQX3oxSjXrkIUF2%1SQvGCe',
        day_difference: 0,
        eticket_train_flag: 1,
        train_type_code: 'G',
        train_type: '高铁',
        special_flag: 1,
        ticket_data: [
          {
            seat_type_name: '二等座',
            seat_type: 'O',
            ticket_num: '有',
            ticket_price: 3350,
            is_support_choose_seats: 1,
            is_can_HB: 0,
            discount: 0,
          },
          {
            seat_type_name: '一等座',
            seat_type: 'M',
            ticket_num: '有',
            ticket_price: 5650,
            is_support_choose_seats: 1,
            is_can_HB: 0,
            discount: 0,
          },
          {
            seat_type_name: '二等卧',
            seat_type: 'J',
            ticket_num: '有',
            ticket_price: 0,
            is_support_choose_seats: 0,
            is_can_HB: 0,
            discount: 0,
          },
          {
            seat_type_name: '一等卧',
            seat_type: 'I',
            ticket_num: '有',
            ticket_price: 0,
            is_support_choose_seats: 0,
            is_can_HB: 0,
            discount: 0,
          },
          {
            seat_type_name: '软座',
            seat_type: '2',
            ticket_num: '13',
            ticket_price: 3350,
            is_support_choose_seats: 0,
            is_can_HB: 0,
            discount: 0,
          },
        ],
        is_support_choose_seats: 1,
        is_start_station: 1,
        is_end_station: 0,
      },
      orderInfo: {
        price: '550',
        state: '已支付',
        tips: '限乘当日当次车',
        ticketCheck: '21',
        seatInfo: {
          seat: '二等座 04车 08D座',
          besideWindow: true,
          silent: true,
        },
        userInfo: {
          username: '周公瑾',
          idType: '二代身份证',
          id: '00000000000001',
        },
      },
      travelSystemVisible: false,
      trainInfoContent: [
        {
          name: '可订坐席',
          value:
            '高铁动车: 高铁无座、二等座、多功能座、二等卧\n普通列车: 无座、硬座、软座、硬卧、包厢硬卧',
        },
        {
          name: '使用期限',
          value: '出差日期的前后4天可用',
        },
      ],
    },
    computed: {},
    methods: {
      /**
       * @description
       */
      seatSelect({ detail }) {
        this.selectSeatInfo = detail
      },
      onSeatClick(event) {
        this.selectType = event.detail
      },
      onSilentClick(event) {
        this.isSilent = event.detail
      },
      travelSystem() {
        this.travelSystemVisible = !this.travelSystemVisible
      },
    },
  })
</script>
<style lang='stylus' scoped>
  @import '~@/mixins/stylus/color.styl'

  .home-main
    background-color $train-color-background
    height 100vh
    box-sizing border-box
    overflow auto
</style>
<script  name="json">
  module.exports = {
    usingComponents: {
      'journey-site': './home/components/journey-site',
      'warm-tips': '@/components/warm-tips',
      'refund-reason-card': '@/components/refund-change-reason-card',
      'travel-system-drawer': '@/components/travel-system-drawer',
    },
  }
</script>
